/**
 * Remembers the ordered invoice ids of the list a detail page was opened from, so the
 * "Send to … → next" review buttons can walk that exact list. Snapshotted when a row is
 * clicked (per tab, via sessionStorage) — later list refetches don't reshuffle the walk.
 */

const KEY = 'catalyst:invoice-list-sequence';

export function rememberInvoiceSequence(ids: string[]): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    /* storage unavailable — the next buttons simply won't show */
  }
}

/** The invoice after `currentId` in the remembered list, or null when absent/last. */
export function nextInvoiceInSequence(currentId: string): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const ids: unknown = JSON.parse(raw);
    if (!Array.isArray(ids)) return null;
    const index = ids.indexOf(currentId);
    if (index < 0 || index + 1 >= ids.length) return null;
    const next: unknown = ids[index + 1];
    return typeof next === 'string' ? next : null;
  } catch {
    return null;
  }
}
